module.exports = __webpack_public_path__ + "static/media/play_button@2x.7bcdd920.png";